import { Directive, ElementRef, Input, OnDestroy, Renderer } from '@angular/core';
import * as currentState from '../global-state/state';
let Chart = require('chart.js');

@Directive({
    selector: 'canvas[chart-type]',
    exportAs: 'ChartType'
})
@Directive({
    selector: 'canvas[chart-data]',
    exportAs: 'ChartData'
})
@Directive({
    selector: 'canvas[chart-options]',
    exportAs: 'ChartOptions'
})
export class BasicChartsDirective implements OnDestroy {
    hostElement: ElementRef;
    basicChart: BasicChartObject;
    canvasElement: any;
    basicChartConfigs: BasicChartOptions = {};
    canvasElementId: string;

    constructor(ele: ElementRef) {
        this.hostElement = ele;
        let val = {};
        currentState.setState(val);
   }

    @Input('id') set id(id: any) {
       if (!id) {
          return;
       }
       if (id) {
          currentState.chart[id] = {};
          this.canvasElementId = id;
       } else {
       }
    }

    @Input('chart-type') set type(type: any) {
       if (!type) {
          return;
       }
       if (type) {
           this.basicChartConfigs.type = type;
          currentState.chart[this.canvasElementId].type = type;
       } else {
       }
    }

    @Input('chart-options') set options(options: any) {
       if (!options) {
          return;
       }
       if (options) {
          if (this.basicChart) {
             this.basicChart = undefined;
          }
          this.basicChartConfigs.options = options;
          this.basicChartConfigs.options.maintainAspectRatio =  false;
       } else {
       }
    }

    @Input('chart-data') set data(data: any) {
       if (!data) {
          return;
       }
       if (data.datasets) {
          if (this.basicChart) {
             this.basicChart = undefined;
          }
          this.basicChartConfigs.data  = data;
          this.canvasElement = this.hostElement.nativeElement;
          this.basicChart = new Chart(this.canvasElement, this.basicChartConfigs);
          currentState.chart[this.canvasElementId].chart_data = data;
          currentState.chart[this.canvasElementId].chart_options = this.basicChartConfigs.options;
          currentState.chart[this.canvasElementId].chart_object = this.basicChart;
       } else {
       }
    }

      ngOnChanges() {
      if (this.basicChart) {
          this.basicChart.update();
       }
      }

    public get chart(): BasicChartObject {
       return this.basicChart;
    }

    public get_chart(): BasicChartObject {
       return this.basicChart;
    }

    ngOnDestroy() {
       if (this.basicChart) {
          this.basicChart = undefined;
       }
    }
}



// WEBPACK FOOTER //
// ./src/common/charts/directives/basic-charts.ts